import { render, staticRenderFns } from "./PageRounds.vue?vue&type=template&id=208e49d8&scoped=true"
import script from "./PageRounds.vue?vue&type=script&lang=js"
export * from "./PageRounds.vue?vue&type=script&lang=js"
import style0 from "./PageRounds.vue?vue&type=style&index=0&id=208e49d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e49d8",
  null
  
)

export default component.exports